// extracted by mini-css-extract-plugin
export default {"ul":"CandidateVacancies_ul__YxUK-","errorLi":"CandidateVacancies_errorLi__jdSLP","sucessLi":"CandidateVacancies_sucessLi__fQmhw"};